import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=6b22e95d&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=6b22e95d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22e95d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b22e95d')) {
      api.createRecord('6b22e95d', component.options)
    } else {
      api.reload('6b22e95d', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=6b22e95d&scoped=true&", function () {
      api.rerender('6b22e95d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20tEJVp73l7Q0/JS/comp/GuestBox.vue"
export default component.exports